import { set } from 'date-fns';

export const getDateFromHoursAndMinutes = ({
  hours,
  minutes,
}: {
  hours: number;
  minutes: number;
}): Date => {
  const d = new Date();
  return set(d, {
    hours,
    minutes,
  });
};
